import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';
import type { PermissionEntity } from '../entities/MembershipEntity.js';

interface Deps { membershipRepository: IMembershipRepository; }
export function createListPermissionsOfRoleUseCase({ membershipRepository }: Deps) {
  return async function listPermissionsOfRole(roleId: string): Promise<PermissionEntity[]> {
    return membershipRepository.listPermissionsOfRole(roleId);
  };
}
